module.exports = __webpack_public_path__ + "static/media/watch_nav_airpods.c6c363d9.svg";